import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import type { ComponentProps } from 'react';
import { memo, useEffect, useState } from 'react';

import { useTranslateFn } from '../Translate';

import { useAudioService } from './useAudioService';

import { competitionUrl } from '@utilities/WindowContext';

import * as classes from './styles.module.scss';

const AudioButton = ({
  appearance = 'outlined',
  onlyIcon,
  highContrast,
  text = 'mc_ui_listen_md_live',
  className,
}: {
  appearance?: ComponentProps<typeof PkButton>['appearance'];
  onlyIcon?: boolean;
  highContrast?: boolean;
  text?: string;
  className?: string;
}) => {
  const t = useTranslateFn();

  const { showButton } = useAudioService();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (!showButton) return;

    setAnimate(true);
    const timeout = setTimeout(() => {
      setAnimate(false);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [showButton]);

  if (!showButton) return null;

  return (
    <PkButton
      className={clsx(onlyIcon ? classes.buttonIcon : classes.button, animate && classes.animate, className)}
      width='auto'
      highContrast={highContrast}
      appearance={appearance}
      linkTarget='uefa-audioplayer'
      linkHref={`/${competitionUrl}/audioplayer/`}
    >
      <PkIcon name='actions-microphone' />
      {!onlyIcon && !!text && <span className='pk-d--none pk-d-md--block pk-line-height--md pk-ml--xs'>{t(text)}</span>}
    </PkButton>
  );
};

export default memo(AudioButton);
